import { Controller } from "@hotwired/stimulus"
import { useFileCollector } from "../mixins/file_collector"
import JSZip from "jszip"

// Connects to data-controller="download"
export default class extends Controller {
  static targets = ["text", "file"]

  connect() {
    useFileCollector(this)
  }

  async download() {
    try {
      const zip = new JSZip()

      // Collect text content and add to zip
      const textContent = this.collectTextContent()
      if (textContent) {
        zip.file('caption.txt', textContent)
      }

      // Collect files and add to zip
      await this.addFilesToZip(zip)

      // Generate and download the zip
      const blob = await zip.generateAsync({ type: 'blob' })
      this.downloadBlob(blob, 'social-post.zip')
    } catch (error) {
      console.error('Error creating download:', error)
    }
  }


  async addFilesToZip(zip) {
    for (const target of this.fileTargets) {
      try {
        let url = null

        if (target.tagName.toLowerCase() === 'img') {
          url = target.src
        } else if (target.tagName.toLowerCase() === 'a') {
          url = target.href
        }

        if (url) {
          const file = await this.fetchAsFile(url, target)
          if (file) {
            zip.file(file.name, file)
          }
        }
      } catch (error) {
        console.error('Error adding file to zip:', error)
      }
    }
  }


  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }
}